// 9fbef606107a605d69c0edbcd8029e5d

const drawHeart = (ctx, size, colors) => {
  ctx.beginPath();
  ctx.moveTo(size, size / 4);
  ctx.bezierCurveTo(size / 2, -size / 4, -size / 2, size / 4, size, size);
  ctx.closePath();
  ctx.fillStyle = colors;
  ctx.fill();
};

export default drawHeart;
